import React, { useEffect, useState } from 'react'
import { Button } from '../../components/ui/Button'
import { LeftArrowWhite } from '../../assets/images/svg/LeftArrow'
import { useNavigate } from "react-router-dom";
import { observer } from 'mobx-react';
import { applicationStore } from 'src/store/ApplicationStore';
import VerificationList from '../../components/VerificationList';
import { useTranslation } from 'react-i18next';
import SelectCountryForm from 'src/components/select-country';
import { fetchForIdVerification } from 'src/services/fetchModelsServices';
import logger from 'src/utils/logger';

const VerificationChoose = observer(() => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const workflowResponse = applicationStore.workflowNextServiceResponse;
    const data = workflowResponse?.response_context;
    const shouldPrefetchModels = Boolean(workflowResponse?.verification);
    const [isCountryConfirmed, setIsCountryConfirmed] = useState(false);

    useEffect(() => {
        if (!data) {
            return;
        }
        applicationStore.setVerifications({
            ...data,
        });
    }, [data]);

    useEffect(() => {
        if (!applicationStore.country || !shouldPrefetchModels) {
            return;
        }

        fetchForIdVerification(applicationStore.country.toLowerCase()).catch((error) => {
            logger.error("Error prefetching verification models:", error);
        });
    }, [shouldPrefetchModels]);

    const handleBack = () => {
        navigate(`/?aid=${applicationStore.aidCode}`, { replace: true });
    };

    const handleCountrySubmit = async (selectedCountry) => {
        if (!selectedCountry) {
            return;
        }

        try {
            const normalizedCountry = selectedCountry.value.toLowerCase();
            applicationStore.setCountry(normalizedCountry);
            applicationStore.setConditionContext({ country: selectedCountry.value });
            applicationStore.setDocumentSurface({
                front: false,
                back: false,
            });
            setTimeout(() => {
                setIsCountryConfirmed(true);
            });
        } catch (error) {
            logger.error("Error handling country selection:", error);
            throw error;
        }
    };

    const initialCountryCode = applicationStore.country
        ? applicationStore.country.toUpperCase()
        : workflowResponse?.country || null;
    const isCompanyFlow = workflowResponse?.id_type === "company";
    const countryTitle = isCompanyFlow ? t('selectCountry.titleKyb') : t('selectCountry.titleKyc');
    const countrySubtitle = isCompanyFlow ? t('selectCountry.subtitleKyb') : t('selectCountry.subtitleKyc');
    const selectedCountries = workflowResponse?.node_settings?.selectedCountries || null;

    return (
        <div className="custom-container">
            <div className="flex flex-col gap-10 w-full">
                <div className='text-left'>
                    <Button className="" variant="primaryBack" onClick={handleBack} ><LeftArrowWhite /></Button>
                </div>
                {!isCountryConfirmed ? (
                    <div className="grid gap-2">
                        <div className="text-h5 font-bold text-flow-heading">{countryTitle}</div>
                        <div className="text-body text-Gray900">{countrySubtitle}</div>
                        <SelectCountryForm
                            compact
                            onSubmit={handleCountrySubmit}
                            initialCountryCode={initialCountryCode}
                            idType={isCompanyFlow ? "kyb" : "kyc"}
                            selectedCountries={selectedCountries}
                        />
                    </div>
                ) : (
                    <>
                        <div className="grid gap-[16px]">
                            <div className="text-h5 font-bold text-flow-heading">{t('verificationChoose.title')}</div>
                            <div className="text-body text-Gray900">{t('verificationChoose.subtitle')}</div>
                        </div>
                        <div className='mt-2'>
                            <div className="text-body text-Gray900">{t('verificationChoose.choose')}</div>
                        </div>
                        <div className="mt-4">
                            <VerificationList data={data ? data : applicationStore.verifications} />
                        </div>
                    </>
                )}
            </div>
        </div>
    )
})

export default VerificationChoose
